import { useContext } from 'react';
import { Dispatch, SetStateAction, SyntheticEvent } from 'react';
import { logger } from '../../utils';
import { AudioDeviceContext } from '../../core';

type TypeNumberPadProps = {
  setDialedInput: Dispatch<SetStateAction<string>>;
};

const KEYPAD_ROWS = [
  [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
  ],
  [
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
  ],
  [
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
  ],
  [
    { value: '*', label: '*' },
    { value: '0', label: '0' },
    { value: '#', label: '#' },
  ],
];

export function NumberPad({ setDialedInput }: TypeNumberPadProps) {
  const {device} = useContext(AudioDeviceContext);
  const numberClickHandler = (event: SyntheticEvent) => {
    const { value } = event.target as HTMLButtonElement;
    //alter the below to accomodate a check for when device is udnefined; hasn't finished being created yet
    device?.calls[0]?.sendDigits(value);
    logger({ message: 'Pressed Pin: ', data: value });
    setDialedInput((previous) => (previous += value));
  };

  return (
    <div className="key-row-wrapper keypad-grid">
      {KEYPAD_ROWS.map((row, rowIndex) => (
        <div className="key-row keypad-grid__row" key={`row-${rowIndex}`}>
          {row.map((key) => (
            <button
              key={key.value}
              value={key.value}
              className="btn btn-light shadow-sm ripple keypad-grid__button"
              type="button"
              onClick={numberClickHandler}
            >
              <span className="keypad-grid__digit">{key.label}</span>
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
